// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"dc3a9adb","207":"84301c9c","389":"336cce22","563":"f153f76c","619":"fc8e64dc"}[chunkId] + ".chunk.js";
};